const createHistory = require("history").createBrowserHistory;

export default createHistory();
export const open = (url, blank) => window.open(url, blank ? '_blank' : undefined);
